var _rect, _rect2, _rect3, _circle, _mask, _path, _circle2, _mask2, _path2, _circle3, _rect4, _circle4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 348,
    viewBox: "0 0 238 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -185.5,
    y: 8.5,
    width: 415,
    height: 143,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -185.5,
    y: 160.5,
    width: 415,
    height: 271,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -193.5,
    y: 0.5,
    width: 431,
    height: 439,
    rx: 23.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 80,
    r: 55.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_1488_2582",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 30C22 26.6863 24.694 23.9667 27.9888 24.3211C37.682 25.3636 46.9728 28.924 54.916 34.695C64.4834 41.6462 71.6047 51.4478 75.2592 62.695C78.9136 73.9423 78.9136 86.0577 75.2592 97.3049C72.2251 106.643 66.8015 114.984 59.5722 121.525C57.1151 123.748 53.337 123.132 51.3893 120.451L43.9597 110.225C42.0119 107.544 42.6597 103.825 44.9212 101.403C48.0349 98.0679 50.4004 94.0755 51.8251 89.6908C53.8716 83.3923 53.8716 76.6077 51.8251 70.3092C49.7786 64.0108 45.7907 58.5219 40.4329 54.6292C36.7031 51.9193 32.4426 50.0799 27.9636 49.2122C24.7104 48.582 22 45.9537 22 42.64L22 30Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 30C22 26.6863 24.694 23.9667 27.9888 24.3211C37.682 25.3636 46.9728 28.924 54.916 34.695C64.4834 41.6462 71.6047 51.4478 75.2592 62.695C78.9136 73.9423 78.9136 86.0577 75.2592 97.3049C72.2251 106.643 66.8015 114.984 59.5722 121.525C57.1151 123.748 53.337 123.132 51.3893 120.451L43.9597 110.225C42.0119 107.544 42.6597 103.825 44.9212 101.403C48.0349 98.0679 50.4004 94.0755 51.8251 89.6908C53.8716 83.3923 53.8716 76.6077 51.8251 70.3092C49.7786 64.0108 45.7907 58.5219 40.4329 54.6292C36.7031 51.9193 32.4426 50.0799 27.9636 49.2122C24.7104 48.582 22 45.9537 22 42.64L22 30Z",
    fill: "#1959E6",
    fillOpacity: 0.16,
    stroke: "#1959E6",
    strokeOpacity: 0.32,
    strokeWidth: 2,
    mask: "url(#path-5-inside-1_1488_2582)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 80,
    r: 55.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_1488_2582",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 30C158 26.6863 160.694 23.9668 163.989 24.3211C169.579 24.9224 175.059 26.3636 180.24 28.6057C187.261 31.644 193.585 36.0886 198.822 41.6654C204.059 47.2421 208.098 53.8327 210.689 61.0307C212.602 66.3425 213.696 71.902 213.945 77.5193C214.092 80.8298 211.209 83.3476 207.901 83.1395L195.286 82.3458C191.979 82.1378 189.526 79.2678 189.101 75.9814C188.811 73.7346 188.277 71.5199 187.506 69.3772C186.055 65.3463 183.793 61.6556 180.86 58.5326C177.928 55.4096 174.386 52.9206 170.455 51.2192C168.365 50.3148 166.188 49.6431 163.963 49.2122C160.71 48.5821 158 45.9537 158 42.64L158 30Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158 30C158 26.6863 160.694 23.9668 163.989 24.3211C169.579 24.9224 175.059 26.3636 180.24 28.6057C187.261 31.644 193.585 36.0886 198.822 41.6654C204.059 47.2421 208.098 53.8327 210.689 61.0307C212.602 66.3425 213.696 71.902 213.945 77.5193C214.092 80.8298 211.209 83.3476 207.901 83.1395L195.286 82.3458C191.979 82.1378 189.526 79.2678 189.101 75.9814C188.811 73.7346 188.277 71.5199 187.506 69.3772C186.055 65.3463 183.793 61.6556 180.86 58.5326C177.928 55.4096 174.386 52.9206 170.455 51.2192C168.365 50.3148 166.188 49.6431 163.963 49.2122C160.71 48.5821 158 45.9537 158 42.64L158 30Z",
    fill: "#10EFE2",
    fillOpacity: 0.16,
    stroke: "#10EFE2",
    strokeOpacity: 0.32,
    strokeWidth: 2,
    mask: "url(#path-7-inside-2_1488_2582)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 192,
    r: 15.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -169.5,
    y: 216.5,
    width: 383,
    height: 15,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 264,
    r: 15.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -169.5,
    y: 288.5,
    width: 383,
    height: 15,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLeft);
export default __webpack_public_path__ + "static/media/graphic-left.5af438f7992d47e6a72ffb09cbb6bf2c.svg";
export { ForwardRef as ReactComponent };